"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * A wrapper function of Element.matches
 * @param element The element to match
 * @param selector The selector to match
 */
function matchesSelector(element, selector) {
    return ((0, safeInstanceOf_1.default)(element, 'HTMLElement') &&
        (element.matches || element.msMatchesSelector).call(element, selector));
}
exports.default = matchesSelector;
//# sourceMappingURL=matchesSelector.js.map